import Cookies from 'universal-cookie';
import { SCID_COOKIE, useModulesStore } from '@wkda/funnel-components';
import { getExperimentData } from '@wkda/funnel-utils';
import { useCarleadConfiguration } from './useCarleadCreationConfiguration';
export function useCarleadCjTracking() {
  const {
    cjTrackingModule: {
      cjTracking
    }
  } = useModulesStore();
  const {
    appName,
    sourceId
  } = useCarleadConfiguration();
  function getEventData() {
    const experimentData = getExperimentData();
    const {
      screen,
      location
    } = window;
    const cookies = new Cookies();
    const scid = cookies.get(SCID_COOKIE);
    return {
      appname: appName,
      category: 'lead-creation',
      source: `${sourceId}`,
      screenSize: {
        width: screen?.width,
        height: screen?.height
      },
      currentUrl: location?.href,
      landingPageName: location?.pathname,
      currentExperimentId: experimentData?.id,
      currentVariant: experimentData?.variant,
      scid
    };
  }
  return {
    trackSuccess(carleadHash) {
      return cjTracking({
        ...getEventData(),
        hash: carleadHash,
        action: 'lead.cta.success'
      });
    },
    trackError(key, error) {
      return cjTracking({
        ...getEventData(),
        hash: '',
        action: 'event.carleadError',
        key,
        error
      });
    },
    trackCustomAction(action) {
      return cjTracking({
        ...getEventData(),
        hash: '',
        action
      });
    }
  };
}